export const RECOMMENDATION_WIDGET_BUY_TOGETHER = 'GK_AIR_AREA_BUY_TOGETHER'
export const RECOMMENDATION_WIDGET_PDP_AVAILABLE = 'GK_AIR_AREA_PDP_AVAILABLE'
export const RECOMMENDATION_WIDGET_LAST_ACTIVITIES =
  'GK_AIR_AREA_LAST_ACTIVITIES'
export const RECOMMENDATION_WIDGET_PDP_OUT_OF_STOCK =
  'GK_AIR_AREA_PDP_OUT_OF_STOCK'
export const RECOMMENDATION_WIDGET_ADD_TO_CART_DISCOUNT =
  'GK_AIR_AREA_ADD_TO_CART_DISCOUNT'
export const RECOMMENDATION_WIDGET_INACTIVITY_MODAL =
  'GK_AIR_AREA_INACTIVITY_MODAL'
export const RECOMMENDATION_WIDGET_ADD_TO_CART_TOP =
  'GK_AIR_AREA_ADD_TO_CART_TOP'
export const RECOMMENDATION_WIDGET_ADD_TO_CART_MIDDLE =
  'GK_AIR_AREA_ADD_TO_CART_MIDDLE'
export const RECOMMENDATION_WIDGET_ADD_TO_CART_BOTTOM =
  'GK_AIR_AREA_ADD_TO_CART_BOTTOM'
export const RECOMMENDATION_WIDGET_FIRST_IMPRESSION =
  'GK_AIR_AREA_FIRST_IMPRESSION'
export const RECOMMENDATION_WIDGET_DELIVERY_TRACKING =
  'GK_AIR_AREA_DELIVERY_TRACKING'
export const RECOMMENDATION_WIDGET_HOME_BOTTOM = 'GK_AIR_AREA_HOME_BOTTOM'
export const RECOMMENDATION_WIDGET_HOME_TOP = 'GK_AIR_AREA_HOME_TOP'
export const RECOMMENDATION_WIDGET_HOME_MIDDLE = 'GK_AIR_AREA_HOME_MIDDLE'
export const RECOMMENDATION_WIDGET_CATEGORY_TOP = 'GK_AIR_AREA_CATEGORY_TOP'
export const RECOMMENDATION_WIDGET_CATEGORY_NOVELTIES =
  'GK_AIR_AREA_CATEGORY_NOVELTIES'
export const RECOMMENDATION_WIDGET_ACCOUNT_MIDDLE = 'GK_AIR_AREA_ACCOUNT_MIDDLE'
export const RECOMMENDATION_WIDGET_ACCOUNT_BOTTOM = 'GK_AIR_AREA_ACCOUNT_BOTTOM'
export const RECOMMENDATION_WIDGET_CART_MIDDLE = 'GK_AIR_AREA_CART_MIDDLE'
export const RECOMMENDATION_WIDGET_CART_BOTTOM = 'GK_AIR_AREA_CART_BOTTOM'
export const RECOMMENDATION_WIDGET_SERP_NO_RESULTS =
  'GK_AIR_AREA_SERP_NO_RESULTS'
export const RECOMMENDATION_WIDGET_CART_FREE_SHIPPING =
  'GK_AIR_AREA_CART_FREE_SHIPPING'

export type RecommendationWidgetType =
  | typeof RECOMMENDATION_WIDGET_ACCOUNT_BOTTOM
  | typeof RECOMMENDATION_WIDGET_ACCOUNT_MIDDLE
  | typeof RECOMMENDATION_WIDGET_ADD_TO_CART_BOTTOM
  | typeof RECOMMENDATION_WIDGET_ADD_TO_CART_DISCOUNT
  | typeof RECOMMENDATION_WIDGET_ADD_TO_CART_MIDDLE
  | typeof RECOMMENDATION_WIDGET_ADD_TO_CART_TOP
  | typeof RECOMMENDATION_WIDGET_BUY_TOGETHER
  | typeof RECOMMENDATION_WIDGET_CART_BOTTOM
  | typeof RECOMMENDATION_WIDGET_CART_FREE_SHIPPING
  | typeof RECOMMENDATION_WIDGET_CART_MIDDLE
  | typeof RECOMMENDATION_WIDGET_CATEGORY_NOVELTIES
  | typeof RECOMMENDATION_WIDGET_CATEGORY_TOP
  | typeof RECOMMENDATION_WIDGET_DELIVERY_TRACKING
  | typeof RECOMMENDATION_WIDGET_FIRST_IMPRESSION
  | typeof RECOMMENDATION_WIDGET_HOME_BOTTOM
  | typeof RECOMMENDATION_WIDGET_HOME_MIDDLE
  | typeof RECOMMENDATION_WIDGET_HOME_TOP
  | typeof RECOMMENDATION_WIDGET_INACTIVITY_MODAL
  | typeof RECOMMENDATION_WIDGET_LAST_ACTIVITIES
  | typeof RECOMMENDATION_WIDGET_PDP_AVAILABLE
  | typeof RECOMMENDATION_WIDGET_PDP_OUT_OF_STOCK
  | typeof RECOMMENDATION_WIDGET_SERP_NO_RESULTS
